import { RestServiceConnection } from '../restServiceConnection';
import { DocumentTypeFieldsModel } from '../../type/entities/document-type';

const ENDPOINT = '/document-types';

export class DocumentTypeService extends RestServiceConnection {

    listDocumentTypes = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    listTutorDocumentTypes = async (filters?: any) => {
        this.response = await this.makeTutorRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    getDocumentTypeById = async (documentTypeId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { documentTypeId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    createDocumentType = async (documentType: DocumentTypeFieldsModel) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: documentType,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    editDocumentType = async (documentType: DocumentTypeFieldsModel) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: documentType,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteDocumentType = async (documentTypeId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { documentTypeId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
}
